import React from 'react'

import { Form, Col } from '_zari/core'

const NombreFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='NOMBRE' htmlFor='input-nombre' xs={12} />
      <Col xs={12}>
        <Form.InputText defaultValue={iValue} disabled id='input-nombre' name='nombre' />
      </Col>
    </Form.Group>
  )
}

export default React.memo(NombreFormGroup)
